import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FAQS } from "../lib/site";

const FAQ = ({ dark = false }) => {
    const [open, setOpen] = useState(0);

    return (
        <div className={`divide-y ${dark ? "divide-white/10" : "divide-ink/10"}`} data-testid="faq-accordion">
            {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                    <div key={f.q}>
                        <button
                            onClick={() => setOpen(isOpen ? -1 : i)}
                            aria-expanded={isOpen}
                            aria-controls={`faq-panel-${i}`}
                            data-testid={`faq-question-${i}`}
                            className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                        >
                            <span className={`font-display text-lg font-bold tracking-tight transition-colors duration-300 sm:text-xl ${dark ? "text-ivory group-hover:text-vantera" : "text-ink group-hover:text-vantera"}`}>
                                {f.q}
                            </span>
                            <span className={`flex size-9 shrink-0 items-center justify-center rounded-full border font-mono text-lg transition-all duration-300 ${isOpen ? "rotate-45 border-vantera text-vantera" : dark ? "border-white/20 text-ivory" : "border-ink/15 text-ink"}`} aria-hidden="true">
                                +
                            </span>
                        </button>
                        <AnimatePresence initial={false}>
                            {isOpen && (
                                <motion.div
                                    id={`faq-panel-${i}`}
                                    role="region"
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                                    className="overflow-hidden"
                                >
                                    <p className={`max-w-3xl pb-7 text-[17px] leading-relaxed ${dark ? "text-cloud" : "text-slategray"}`}>{f.a}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
};

export default FAQ;